import { render, staticRenderFns } from "./delete-modal.vue?vue&type=template&id=40151a7e&scoped=true"
import script from "./delete-modal.vue?vue&type=script&lang=js"
export * from "./delete-modal.vue?vue&type=script&lang=js"
import style0 from "./delete-modal.vue?vue&type=style&index=0&id=40151a7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40151a7e",
  null
  
)

export default component.exports